/**
 * @Author: longZhi
 * @Date: 2025-09-29 16:00
 * @LastEditors: longZhi
 * @Description: WebSocket消息统一处理
 */
import useUsersStore from "@/stores/user";

// 统一处理socket信息
const handleSocketMessage = (message) => {
  const usersStore = useUsersStore();
  if (message) {
    const type = message.msgType;
    // 客户权限变更通知
    if (type == 1) {
      handleUserAuth(message, usersStore);
    };
    // 共享屏幕会议通知
    if (type == 2) {
      handleMeetingCreate(message, usersStore);
    };
  }
};

// 屏幕共享消息处理 打开 or 关闭
const handleMeetingCreate = (data, usersStore) => {
  usersStore.setScreenSharingPopup(data.message.isSharing);
  usersStore.setScreenSharingRoomId(data.message.isSharing ? data.message.roomId : '');
  usersStore.setScreenSharingUserName(data.message.isSharing ? data.message.userName : '');
  usersStore.setScreenSharingUserAvatar(data.message.isSharing ? data.message.avatar : '');
};

// 用户权限变更消息
const handleUserAuth = (data, usersStore) => {
  // 发送类型为2时，指定用户
  if (data.sendType == 2) {
    const userInfo = { ...usersStore.newUserInfo };
    const nowRelationInfo = {
      ...userInfo.userRelationInfo,
      ...data.message
    };
    userInfo.userRelationInfo = nowRelationInfo;
    usersStore.setNewUserInfo(userInfo);
  };
};

export default handleSocketMessage;
